import logo from './Logo';
import types from './logo.types';

export { types };
export default logo;
